import React, { useRef, useState } from "react";
import { IconButton, Tooltip, SnackbarOrigin, Button } from "@mui/material";

// import UploadFileIcon from '@mui/icons-material/AddCircleOutline';
import UploadFileIcon from "@mui/icons-material/Publish";
import axios from "../../../utils/axiosInstance";
import GeneralModalV1 from "../../UI/atoms/Popup/GeneralModalV1";

const ExcelUploadButton = ({
    s3Prefix,
    currents3Env,
    setLoader,
    enqueueSnackbar,
    gets3Objects,
}: any) => {
    const [showUploadConfirmationPopup, setShowUploadConfirmationPopup] =
        useState(false);
    const [selectedMetadataFile, setSelectedMetadataFile] = useState<any>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const handleUploadMetadataFile = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const file = e.target.files?.[0];
        if (file) {
            const allowedExtensions = [
                ".xlsx",
                ".png",
                ".jpeg",
                ".jpg",
                ".xml",
                ".txt",
                ".srt",
            ];
            const fileName = file.name.toLowerCase();

            const isValid = allowedExtensions.some((ext) =>
                fileName.endsWith(ext)
            );

            if (!isValid) {
                enqueueSnackbar(
                    "Only xlsx, png, jpg/jpeg, xml, txt files are allowed",
                    {
                        variant: "error",
                    }
                );
                e.target.value = ""; // reset input so the same file can be reselected
                return;
            }

            setSelectedMetadataFile(file);
            setShowUploadConfirmationPopup(true);
        }
    };

    const closeUploadConfirmationPopup = () => {
        setShowUploadConfirmationPopup(false);
        setSelectedMetadataFile(null);
    };

    const confirmUpload = () => {
        uploadFileAPI(selectedMetadataFile);
        setShowUploadConfirmationPopup(false);
        setSelectedMetadataFile(null);
    };

    const uploadFileAPI = async (file: any) => {
        setLoader(true);
        try {
            if (file) {
                const formData = new FormData();
                formData.append("file", file);
                const uploadFile: any = await axios.post(
                    `${process.env.BASE_URL}api/v1/cms/ingest/upload-template?filePath=${s3Prefix}&s3Env=${currents3Env}`,
                    formData
                );
                if (uploadFile?.data?.success) {
                    enqueueSnackbar("File uploaded successfully.", {
                        variant: "success",
                    });
                    gets3Objects(s3Prefix, false);
                }
            }
        } catch (error: any) {
            console.log("Error uploading", error.response.data.message);
            enqueueSnackbar("An error occurred while uploading the file.", {
                variant: "error",
            });
        } finally {
            setLoader(false);
        }
    };

    const handleClick = () => {
        if (inputRef.current) {
            inputRef.current.value = "";
            inputRef.current.click();
        }
    };
    if (!s3Prefix) return null;

    return (
        <div
            className="d-flex j-end"
            style={{ marginLeft: "10px", height: "100%" }}
        >
            <Tooltip title="Upload File">
                <Button
                    className="button-pd-s"
                    onClick={handleClick}
                    variant="outlined"
                    style={{ height: "100%" }}
                >
                    <UploadFileIcon />
                </Button>
            </Tooltip>
            <input
                ref={inputRef}
                type="file"
                accept=".xlsx, .jpg, .jpeg, .png, .xml, .srt, .txt"
                onChange={handleUploadMetadataFile}
                style={{ display: "none" }}
            />

            <GeneralModalV1
                title="Confirm upload"
                isOpen={showUploadConfirmationPopup}
                handleClose={closeUploadConfirmationPopup}
                handleConfirm={confirmUpload}
            >
                <p>
                    {" "}
                    Are you sure you want to upload the metadata file{" "}
                    {selectedMetadataFile && selectedMetadataFile?.name}?
                </p>
            </GeneralModalV1>
        </div>
    );
};

export default ExcelUploadButton;
